import { Component, ViewEncapsulation, OnInit, ViewContainerRef, ViewChild } from '@angular/core';
import { KYMW1400KomaPageComponent } from '../kymw1400-koma-page/kymw1400-koma-page.component';
import { KYMW1400Model } from '../kymw1400.model';

/**
 * コマ割（右ページ）を管理するクラス
 *
 * @export KYMW1400KomaPageRightComponent
 * @class KYMW1400KomaPageRightComponent
 */
@Component({
  selector: 'app-kymw1400-koma-page-right',
  templateUrl: 'kymw1400-koma-page-right.component.html',
  styleUrls: ['kymw1400-koma-page-right.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1400KomaPageRightComponent {
  @ViewChild('KYMW1400KomaPageRightViewHelper', { static: true }) KYMW1400KomaPageRightViewHelper: KYMW1400KomaPageComponent;

  /**
   *Creates an instance of KYMW1400KomaPageRightComponent.
   * @param {KYMW1400Model} kymw1400Model
   * @memberof KYMW1400KomaPageRightComponent
   */
  constructor(
    private kymw1400Model: KYMW1400Model,
  ) {
  }

  /**
   * 【ページエリア】をユーザーがクリックした時
   */
  public eventWindow_MOUSE_DOWNHandler(): void {
    // ヘッダの選択色変更
    this.kymw1400Model.leftManage.selectedBarStyle = 'noSelectedBarColor';
    this.kymw1400Model.rightManage.selectedBarStyle = 'selectedBarColor';

    if (this.kymw1400Model.leftPageSelected) {
      // ページ選択フラグを設定する
      this.kymw1400Model.leftPageSelected = false;

      // 画面メニュー、ボタンの活性化・非活性化制御を行う
      this.kymw1400Model.updateMenuAndButtonEnable();

      // モードレスでポップアップしている画面を再表示する。
      this.kymw1400Model.kymw1400Component.sendInputVOToAllPopupDialog();
    }

    this.kymw1400Model.leftView.page.selected = false;
    this.kymw1400Model.rightView.page.selected = true;
  }
}
